/**
 * Etiquetas de estado. El color es semantico y estable en toda la UI: verde
 * procesado, ambar reintentando o en cuarentena, rojo dead letter.
 */
import type { ReactElement } from 'react';
import type { FlowNodeStatus, MessageDirection, MessageStatus } from '../api/contracts';
import { directionLabel, runStatusLabel, statusLabel } from '../lib/catalogs';
import '../styles/flow-runs.css';

export function StatusBadge({ status }: { readonly status: MessageStatus }): ReactElement {
  return <span className={`badge badge--${status}`}>{statusLabel(status)}</span>;
}

/** Estado de una corrida entera: los mismos colores que su caja en el grafo. */
export function RunStatusBadge({ status }: { readonly status: FlowNodeStatus }): ReactElement {
  return <span className={`badge badge--run-${status}`}>{runStatusLabel(status)}</span>;
}

export function DirectionBadge({
  direction,
}: {
  readonly direction: MessageDirection;
}): ReactElement {
  return <span className={`badge badge--${direction}`}>{directionLabel(direction)}</span>;
}

/** Resultado de un intento: `ok` o `error`. */
export function OutcomeBadge({ outcome }: { readonly outcome: string }): ReactElement {
  const label = outcome === 'ok' ? 'Éxito' : 'Error';
  return <span className={`badge badge--${outcome}`}>{label}</span>;
}
